import { render, staticRenderFns } from "./whatsapp-buttom.vue?vue&type=template&id=ae56aa78"
import script from "./whatsapp-buttom.vue?vue&type=script&lang=js"
export * from "./whatsapp-buttom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports